import { defineVizView } from "@/lib/ai/visualization/views/shared/view-definition";
import {
  buildTimeSeriesGroupedLineElement,
  compileTimeSeriesGroupedLineSpec,
  validateTimeSeriesGroupedLineSpec,
} from "@/lib/ai/visualization/views/time-series-grouped-line/logic";
import { timeSeriesGroupedLineAuthoringSchema } from "@/lib/ai/visualization/views/time-series-grouped-line/schema";

/**
 * `time-series-grouped-line` definition の SSOT エントリ。
 */
export const timeSeriesGroupedLineDefinition = defineVizView({
  type: "time-series-grouped-line",
  componentType: "TimeSeriesGroupedLine",
  authoringSchema: timeSeriesGroupedLineAuthoringSchema,
  authoringPrompt: {
    summary:
      "Long-form grouped time-series where color represents the group and line style represents the metric on one time axis.",
    requiredKeys: [
      "xKey",
      "xLabel",
      "groupKey",
      "metricKeys",
      "metricLabelEntries",
    ],
    optionalKeys: [],
    selectionRules: [
      "metricKeys must contain one or more metric keys.",
      "groupKey must point to the grouping dimension that should control color and visibility.",
      "Choose this view only when separate group identities must stay visible across time instead of collapsing into one total line.",
      "Always provide xLabel in task.outputLanguage.",
      "Always provide metricLabelEntries using selected metric keys only, and cover every selected metric key.",
    ],
    avoidWhen: [
      "Very large group counts that would overload one trend chart.",
      "Single wide-metric timelines that a plain time-series-line already expresses cleanly.",
    ],
    minimalExamples: [
      {
        label: "grouped-trend",
        view: {
          type: "time-series-grouped-line",
          xKey: "date",
          xLabel: "Date",
          groupKey: "channel",
          metricKeys: ["sessions"],
          metricLabelEntries: [{ key: "sessions", label: "Sessions" }],
        },
      },
    ],
  },
  datasetRequirements: {
    requiresTimeDimension: true,
    requiresCategoryDimension: false,
    minMetricCount: 1,
    requiresCompareMode: false,
  },
  validateSpec: validateTimeSeriesGroupedLineSpec,
  buildElement: buildTimeSeriesGroupedLineElement,
  compileSpec: compileTimeSeriesGroupedLineSpec,
});
